export default "__VITE_ASSET__DXoHWupF__"